import { SVGProps, Ref, forwardRef } from 'react';

export const CheckboxLineSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M12 8.6H4V7.4h8z" fill="currentColor" />
    </svg>
));
CheckboxLineSize16Glyph.displayName = 'CheckboxLineSize16Glyph';
